import {
    COMPLETE_PARTIAL,
    CompletePartialAction,
    CompletePartialError,
    CompletePartialState,
    COMPLETE_PARTIAL_ERROR,
    COMPLETE_PARTIAL_SUCCESS,
    COMPLETE_PARTIAL_INITIAL,
} from '../_types/completePartial';

const initialState: CompletePartialState = {
    data: null,
    loading: false,
    error: null,
};

export default (state = initialState, action: CompletePartialAction): CompletePartialState => {
    switch (action.type) {
        case COMPLETE_PARTIAL_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: {} as CompletePartialError,
            };
        case COMPLETE_PARTIAL:
            return {
                ...state,
                loading: true,
            };
        case COMPLETE_PARTIAL_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case COMPLETE_PARTIAL_INITIAL:
            return initialState;
        default:
            return state;
    }
};
